<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-delete"
      title="Delete User"
      ok-only
      ok-title="Delete"
      @ok="deleteItem"
    >
      <b-card-text>
        <h5>Are You Sure You Want to Remove This Doctor</h5>
        If you want to remove this Doctor, click the button below.
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      no-close-on-backdrop
      ok-only
      centered
      size="lg"
      :title="createMode ? 'Add Surgery' : 'Edit Surgery'"
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <!-- <b-col md="">
            <AutoComplete
              label="Doctor"
              placeholder="Select Doctor"
              v-model="EditForm.doctor_id"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="doctor"
              text-title="name"
            />
          </b-col> -->
          <!-- <b-col md="">
            <AutoComplete
              label="Surgery"
              placeholder="Select Surgery"
              v-model="EditForm.surgery_id"
              :serializer="(val) => val.id"
              param-query="search"
              endpoint="surgery"
              text-title="title"
            />
          </b-col> -->
          <b-col md="">
            <b-form-group label="Price" label-for="PRICE">
              <b-form-input
                type="number"
                v-model="EditForm.price"
                placeholder="Surgery Price"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card title="Doctors Surgries">
      <!-- Search Patient Name -->
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h3>Filter Surgries</h3>
            <br />
          </b-col>

          <b-col md="4" cols="12">
            <AutoComplete
              label="Doctor"
              placeholder="Select Doctor"
              v-model="doctorFilter"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="doctor"
              text-title="name"
            />
          </b-col>
          <b-col md="4" cols="12">
            <AutoComplete
              label="Surgery"
              placeholder="Select Surgery"
              v-model="surgeryFilter"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="surgery"
              text-title="title"
            />
          </b-col>
          <b-col md="4" cols="12">
            <b-form-group label="Surgery Price" label-for="Name">
              <b-form-input
                type="number"
                v-model="priceFilter"
                placeholder="Surgery Price"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getDoctorSurgeries()">
              Search <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <!-- <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>Doctors Table</h2>
          <b-button
            v-if="$store.state.app.permissions.includes('store-doctorSurgery')"
            variant="primary"
            @click="show(EditForm, 'create')"
          >
            Create Doctor Surgery
          </b-button>
        </div> -->

        <b-table
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative mt-4"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->

              <!-- Dropdown -->
              <b-dropdown
                variant="link"
                toggle-class="p-0"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item
                  v-if="
                    $store.state.app.permissions.includes(
                        'update-invoice'
                      )
                    "
                  @click="show(data.item)"
                >
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">Edit</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    $store.state.app.permissions.includes(
                      'delete-invoice'
                    )
                  "
                  @click="deleteModel(data.item)"
                >
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">Delete</span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing 1 to 10 Doctors</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getDoctorSurgeries()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");

import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    AutoComplete,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        doctor_id: "",
        surgery_id: "",
        price: "",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        doctor_id: "",
        surgery_id: "",
        price: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "doctor_name", sortable: true },
        { key: "surgery_name", sortable: true },
        { key: "price", sortable: true },
        { key: "created_at", sortable: true },
        { key: "Actions" },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      doctorFilter: null,
      surgeryFilter: null,
      priceFilter: null,
    };
  },
  mounted() {
    this.getDoctorSurgeries();
  },
  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          doctor_id: "",
          surgery_id: "",
          price: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.doctor_id = item.doctor_id;
        this.EditForm.surgery_id = item.surgery_id;
        this.EditForm.price = item.price;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },

    async getDoctorSurgeries() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/doctorSurgery?page=${this.page}&take=${this.take}&sort=-id`;

      if (this.doctorFilter) {
        url += `&filter[doctor_id]=${this.doctorFilter}`;
      }
      if (this.surgeryFilter) {
        url += `&filter[surgery_id]=${this.surgeryFilter}`;
      }
      if (this.priceFilter) {
        url += `&filter[price]=${this.priceFilter}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/doctorSurgery/${this.deleteForm.id}`)
        .then((response) => {
          this.getDoctorSurgeries();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/doctorSurgery`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getDoctorSurgeries();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/doctorSurgery/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getDoctorSurgeries();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
